module.exports = __webpack_public_path__ + "static/graph-a575708df5e53c00ed2cea19ae32c1e9.svg";